document.addEventListener("DOMContentLoaded", () => {
  const speeds = {
    "ticker--about": 22,
    "ticker--shop": 14,
    "ticker--terms": 28,
    "ticker--return": 18,
    "ticker--faq": 20,
    "ticker--privacy": 24,
    "ticker--contact": 10,
  };

  document.querySelectorAll(".home .ticker").forEach((row) => {
    const cls = [...row.classList].find(c => c.startsWith("ticker--"));

    if (cls && speeds[cls]) {
      const track = row.querySelector(".ticker__track");

      if (track) {
        track.style.animationDuration = `${speeds[cls]}s`;
      }
    }
  });
});